import { useMediaQuery } from "react-responsive";
import { useState } from "react";
import { IconMenu2, IconX, IconHeart } from "@tabler/icons-react";

import { Link } from "react-router-dom";
export const Navbar = ({ setTitle }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const toggleNavOpen = () => {
    setIsNavOpen(!isNavOpen);
  };
  return (
    <>
      <nav className="navbar">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            columnGap: "1rem",
            alignItems: "center",
          }}
        >
          <div className="logo-pikapika">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fpokemon-letter.png?alt=media&token=37ee4f2c-dd0f-4fb6-b226-94950c416d8f"
              alt=""
              className="logo-img-pika"
            />
          </div>
          <div className="logo-pokedex"> — pandasneezing</div>
        </div>

        {isMobile ? (
          <div>
            <button
              onClick={toggleNavOpen}
              className="hamburger-button"
              aria-label="Toggle menu"
            >
              {isNavOpen ? <IconX size={28} /> : <IconMenu2 size={28} />}
            </button>

            {isNavOpen && (
              <ul className="mobile-menu slide-bottom-menu">
                <li onClick={() => setTitle("Home")}>
                  <Link
                    onClick={() => setIsNavOpen(false)}
                    className="nav-link"
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li onClick={() => setTitle("About")}>
                  <Link
                    onClick={() => setIsNavOpen(false)}
                    className="nav-link"
                    to="/about"
                  >
                    About
                  </Link>
                </li>
                <li onClick={() => setTitle("Pokedex")}>
                  <Link
                    className="nav-link"
                    to="/pokedex"
                    onClick={() => setIsNavOpen(false)}
                  >
                    Pokedex
                  </Link>
                </li>
                <li onClick={() => setTitle("Contact — pandasneezing ")}>
                  <Link
                    className="nav-link"
                    to="/contact"
                    onClick={() => setIsNavOpen(false)}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            )}
          </div>
        ) : (
          <ul>
            <li onClick={() => setTitle("Pokedex | pandasneezing ")}>
              <Link className="nav-link" to="/">
                HOME
              </Link>
            </li>
            <li onClick={() => setTitle("About — Project")}>
              <Link className="nav-link" to="/about">
                ABOUT
              </Link>
            </li>
            <li onClick={() => setTitle("Pokedex — Catch 'em all")}>
              <Link className="nav-link" to="/pokedex">
                POKEDEX
              </Link>
            </li>
            <li onClick={() => setTitle("Contact — pandasneezing")}>
              <Link className="nav-link" to="/contact">
                CONTACT
              </Link>
            </li>
            <li>
              <Link onClick={() => console.log("Esto abre el login")}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0 6px",
                    gap: "4px",
                  }}
                >
                  <IconHeart size={24} color="red" />
                  <p>Join PANDA® Comunity</p>
                </div>
              </Link>
            </li>
          </ul>
        )}
        {/*<div className="indicator"></div>  Barra de selección */}
      </nav>
    </>
  );
};

export default Navbar;
